import { defineComponent as _defineComponent } from 'vue'
import {PropType} from "vue";
import {useI18n} from "@/composables/useI18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateInput',
  props: {
  label: {
    required: true,
    type: String as PropType<string>
  },
  modelValue: {
    required: false,
    type: String as PropType<string>,
    default: undefined,
  },
  rules: {
    required: false,
    type: Array as PropType<any>,
    default: undefined
  },
  allowedDates: {
    required: false,
    type: [Function, undefined] as PropType<void | undefined>,
    default: undefined,
  },
  minDate: {
    required: false,
    type: String as PropType<string>,
    default: ''
  },
  prependIcon: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  disabled: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  emits: [
  'update:modelValue',
],
  setup(__props, { emit: emits }) {

const props = __props;

const { d } = useI18n();



const formatDate = (date: string | undefined) => {
  if(!date) return;

  const parsedDate = Date.parse(date);
  if (Number.isNaN(parsedDate)) return '';

  return d(parsedDate, 'short');
}

const getAllowedDates = (val: string) => {
    if(!props.allowedDates) return true;

    return props.allowedDates(val);
}



const onHandleDateClear = () => {
  emits('update:modelValue', undefined);
}

const onHandleDateChange = (value: string) => {
  emits('update:modelValue', value);
}

return { __sfc: true,d, props, formatDate, getAllowedDates, emits, onHandleDateClear, onHandleDateChange }
}

})